import { httpClient } from '@/utils/httpClient';
import type { NotifyEnvelope } from '@/types/api';

export const getKeepUntilDays = async (): Promise<number> => {
  const { data } = await httpClient.get<NotifyEnvelope<number>>(
    '/account/keep-for-days'
  );
  return data.Response ?? 0;
};

export const updateKeepUntilDays = async (keepUntilDays: number): Promise<void> => {
  await httpClient.put('/account/update-keep-until-days', {
    keepUntilDays: String(keepUntilDays),
  });
};
